/*

Events triggered:

jrpCookies:ConsentChange - when cookie consent status has changed


//@codekit-prepend "inc/cookies.js"

*/

var JRPCookies = (function ($) {

	var $banner;
	var $cookieCheckboxes;
	var $cookiePreferences;
	var $managePreferences;
	var $closeBanner;
	var cookieCategories = [];
	var $openPreferencesBanner;
	var $bannerBackground;
	var hasScrolled = false;
	var landingTime;

	$(document).ready( function() {

		// Create global element references
		$banner = $('#jrp_cookie_banner');
		$cookieCheckboxes = $banner.find('input[type=checkbox]');
		$cookiePreferences = $banner.find('.cookie-preferences');
		$managePreferences = $banner.find('.manage-preferences');
		$closeBanner = $banner.find('.close-banner');
		$openPreferencesBanner = $('.open-cookie-preferences-banner');
		$bannerBackground = $('#jrp-cookie-banner-bg');

		// Set time
		var date = new Date();
		landingTime = date.getTime();

		// Get cookie categories
		$cookieCheckboxes.each( function() {
			var $this = $(this);
			var cookieCategory = $this.val();
			cookieCategories.push(cookieCategory);
		});

		// Open the banner if consent hasn't been given
		if ( ! hasBannerBeenDismissed() ) {

			openBanner();
			
		}

		// Expand cookie preferences
		$managePreferences.click( function() {
			openBanner(true);
		});

		// Open the banner
		$openPreferencesBanner.click( function() {
			openBanner(true);
		});

		// Apply consents on Accept button click
		$closeBanner.on('click', function(){
			applyConsents();
			closeBanner();
		});

		// Close banner on background click
		$bannerBackground.on('click', function() {

			if ( hasBannerBeenDismissed() ) {
				closeBanner();
			} else {
				closeBanner(true);
			}
			
		});

		// Trigger all consented events
		triggerConsentedEvents();

		if ( ! hasBannerBeenDismissed() ) {

			// Apply consents when user continues to browse the website
			$(document).on('scroll', function() {

				// Return if already dismissed
				if ( hasScrolled === true ) {
					return;
				}

				// Make sure notice is up for a good amount of time
				var date = new Date();
				var now = date.getTime();

				if ( ( landingTime + 5000 ) > now ) {
					return;
				}

				// Dont dismiss if cookie preferences are open
				if ( $('body').hasClass('jrp-cookies-banner-extension-open') ) {
					return 
				}

				// Dont dismiss if on cookie policy page
				if ( $('body').hasClass('page-id-' + JRPCookiesPhpVars.cookiePolicyPageID ) ) {
					return;
				}

				hasScrolled = true;
				applyConsents();
				closeBanner();

			});

		}

		
		
	});


	/**
	 * Open the cookie notice banner
	 * @param {boolean} extend show the cookie preferences
	 */
	var openBanner = function( extend = false ) {

		if ( extend ) {

			if ( $('body').hasClass('jrp-cookies-banner-open') ) {
				$cookiePreferences.slideDown();
			} else {
				$cookiePreferences.show();
			}

			$('body').addClass('jrp-cookies-banner-extension-open');
			
		}

		$banner.slideDown();
		$('body').addClass('jrp-cookies-banner-open');

	}


	/**
	 * Close the cookie notice banner
	 */
	var closeBanner = function( extensionOnly = false ) {

		if ( extensionOnly ) {
			$cookiePreferences.slideUp();
		} else {
			$('body').removeClass('jrp-cookies-banner-open');
			$banner.slideUp();
		}

		$('body').removeClass('jrp-cookies-banner-extension-open');

	}


	/**
	 * Get the current consent data for each cookie category
	 */
	var getCheckboxConsents = function() {

		var chackboxConsents = [];

		$cookieCheckboxes.each(function() {

			var $this = $(this);
			var cookieCategory = $this.val();

			if ( $this.prop('checked') ) {
				chackboxConsents.push(cookieCategory);
			}

		});

		return chackboxConsents;

	}


	/**
	 * Get the current consented categories
	 */
	var getCurrentConsents = function() {

		var currentConsents = [];

		for( var i = 0; i < cookieCategories.length; i++ ) {

			// Get cookies
			var consent = Cookies.get('jrp_cookies_' + cookieCategories[i]);

			// User has consented to cookie category
			if ( 'yes' === consent ) {
				currentConsents.push( cookieCategories[i] );
			}

		}

		return currentConsents;

	}


	/**
	 * Update each cookie category consent based on continued use of the website, accepting the banner or changing the value of a checkbox
	 */
	var applyConsents = function() {

		if ( ! hasBannerBeenDismissed() ) {
			// Set banner dismissal cookie
			Cookies.set('jrp_cookies_banner', 'dismissed', { expires: 31536000 } ); // 1 year

		}

		for( var i = 0; i < cookieCategories.length; i++ ) {

			var category = cookieCategories[i];
			var consents = getCheckboxConsents();

			// User has consented to cookie category
			if ( $.inArray( category, consents ) > -1 ) {
				acceptCookieCategory( category );
			} else {
				revokeCookieCategory( category );
			}

		}

		recordConsent();

	}


	/**
	 * Check if a category has user consent
	 * @param {*} category 
	 */
	var categoryHasConsent = function( category ) {

		var consents = getCurrentConsents();

		if ( $.inArray( category, consents ) > -1 ) {
			return true;
		} 
	
		return false;

	}


	/**
	 * Checks to see if the banner has been dismissed
	 */
	var hasBannerBeenDismissed = function() {

		if ( Cookies.get('jrp_cookies_banner') === 'dismissed' ) {
			return true;
		}

		return false;

	}


	/**
	 * Records the action of the user consenting
	 */
	var recordConsent = function() {

		var consents = getCurrentConsents();

		if ( consents.length === 0 ) {
			return;
		}

		// Trigger event
		$(document).trigger( 'jrpCookies:recordConsents', [
			consents
		] );


	}


	/**
	 * Accept the users preference for this category
	 * @param {string} category 
	 */
	var acceptCookieCategory = function( category ) {

		Cookies.set('jrp_cookies_' + category, 'yes', { expires: 31536000 } ); // 1 year
		triggerEvent( category, 'accept' );

	}


	/**
	 * Decline the users preference for this category
	 * @param {string} category 
	 */
	var revokeCookieCategory = function( category ) {
		Cookies.set('jrp_cookies_' + category, 'no', { expires: 31536000 } ); // 1 year
		triggerEvent( category, 'revoke' );

	}

	/**
	 * 
	 * @param {*} cookieCategory 
	 * @param {*} event 
	 */
	var triggerEvent = function( cookieCategory, event ) {

		$(document).trigger( 'jrpCookies:' + cookieCategory + ':' + event );

	}


	/**
	 * Trigger all actions that have been consented to
	 */
	var triggerConsentedEvents = function() {

		var consents = getCurrentConsents();

		if ( consents.length === 0 ) {
			return;
		}

		for( var i = 0; i < consents.length; i++ ) {
			acceptCookieCategory(consents[i]);
		}

	}


	return {
		banner: $banner,
		cookieCheckboxes: $cookieCheckboxes
	}


}(jQuery));


